import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link } from 'react-router-dom';
import './MonitoredIndividualUnitSearch.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleMIUserCard from '../SimpleMIUserCard/SimpleMIUserCard';
import { AdminContext } from '../../contexts/AdminContext';
import UnitCard from '../UnitCard/UnitCard';
import logComponent from '../../common/logComponent';

export default function MonitoredIndividualUnitSearch({ readOnly }) {
  const adminContext = useContext(AdminContext);
  const [inputValue, setInputValue] = useState('');
  const [showOverlay, setShowOverlay] = useState(true);
  const [filteredItems, setfilteredItems] = useState([]);
  const { monitoredIndividuals, units } = adminContext;

  const overlayRef = useRef(null);
  const firstItemRef = useRef(null);
  const lastItemRef = useRef(null);
  const inputRef = useRef(null);

  const setOverlayRef = (el) => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch setOverlayRef'); }
    overlayRef.current = el
  };
  const setFirstItemRef = (el) => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch setFirstItemRef'); }
    firstItemRef.current = el
  };
  const setLastItemRef = (el) => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch setLastItemRef'); }
    lastItemRef.current = el
  };
  const setInputRef = (el) => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch setInputRef'); }
    inputRef.current = el
  };

  if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch rendered'); }

  useEffect(() => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch useEffect  [inputValue]'); }
    handleInputValueChange();
  }, [inputValue])


  const hideOverlay = () => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch hideOverlay'); }
    overlayRef.current.scrollTo(0,0);

    setInputValue('');
    setShowOverlay(false);
  }

  const updateValue = (e) => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch updateValue'); }
    setInputValue(e.target.value);
  }

  const handleKeyDown = (e) => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch handleKeyDown'); }
    const { key } = e;

    if (key && key == 'Escape') {
      setInputValue('');
      setShowOverlay(false);
    }
  }

  const handleInputValueChange = () => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch handleInputValueChange'); }

    if (inputValue.length <= 2) {
      setShowOverlay(false);
      return;
    }

    const searchableItems = [];
    if (monitoredIndividuals) searchableItems.push(...monitoredIndividuals);
    if (units) searchableItems.push(...units);

    let filteredItems = searchableItems.filter(item => {
      let textsToSearch = [];

      if (item.monitoredIndividualId) {
        textsToSearch.push(item.legalFirstName + ' ' + item.lastName);

        if (item.monitoredIndividualUnits) {
          item.monitoredIndividualUnits.forEach(unit => {
            if (!unit.EndOn) {
              textsToSearch.push(unit.unit.name);
            }
          });
        }
  
        if (item.preferredFirstName) {
          textsToSearch.push(item.preferredFirstName + ' ' + item.lastName);
        }        
      } else if (item.unitId) {
        textsToSearch.push(item.name);
      }

      return textsToSearch.some(text => text.toLowerCase().includes(inputValue.toLowerCase()));
    });

    setfilteredItems(filteredItems);
    setShowOverlay(true);
  }

  const handleInputKeyDown = (e) => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch handleInputKeyDown'); }
    const { key, shiftKey } = e;

    // if overlay is not shown, bail
    if (!showOverlay) return;
    
    // if overlay is shown, but there are not any filtered individuals, hide on tab or shift-tab
    if (filteredItems.length === 0 && key === 'Tab') {
      hideOverlay();
      return;
    }  
    
    if ((key === 'Tab' && !shiftKey) || key === 'ArrowDown') {
      firstItemRef.current.focus();
      e.preventDefault();
    } else if ((key === 'Tab' && shiftKey) || key === 'ArrowUp') {
      if (firstItemRef.current && !lastItemRef.current) {
        firstItemRef.current.focus()
      } else {
        lastItemRef.current.focus()
      }

      e.preventDefault();
    }
  }

  const handleMonitoredIndividualButtonKeyDown  = (e) => {
    if (logComponent('MonitoredIndividualUnitSearch')) { console.debug('MonitoredIndividualUnitSearch handleMonitoredIndividualButtonKeyDown'); }
    const { key, shiftKey } = e;
    
    if ((key === 'Tab' && !shiftKey) || key === 'ArrowDown') {
      e.preventDefault();

      let nextItem = e.currentTarget.nextElementSibling;
      
      if (!nextItem) {
        inputRef.current.focus();
        return;
      }

      let nextButton = nextItem.querySelector('.Monitored-Individual-Unit-Search__monitoredindividual-button');
      nextButton.focus();

    } else if ((key === 'Tab' && shiftKey) || key === 'ArrowUp') {
      e.preventDefault();

      let prevItem = e.currentTarget.previousElementSibling;

      if (!prevItem) {
        inputRef.current.focus();
        return;
      }

      let prevButton = prevItem.querySelector('.Monitored-Individual-Unit-Search__monitoredindividual-button');
      prevButton.focus();
    }    
  }

    const searchSortFilter = (a, b) => {
      let aFirstName = null;
      let bFirstName = null;
      let aLastName = null;
      let bLastName = null;
      let aUnitName = null;
      let bUnitName = null;
      if (a.hasOwnProperty('legalFirstName')) {
        aFirstName = a.legalFirstName.toLowerCase();
        aLastName = a.lastName.toLowerCase();  
      }
      if (b.hasOwnProperty('legalFirstName')) { 
        bFirstName = b.legalFirstName.toLowerCase();
        bLastName = b.lastName.toLowerCase();
      }
      if (aFirstName == "") aFirstName = "zzzzzzzzzzzzzzzzzz"; // Push objects for individuals without a first name to bottom of list (i.e. Vacant).
      if (bFirstName == "") bFirstName = "zzzzzzzzzzzzzzzzzz"; // 'Individuals without first names will be sorted alphebetically at the bottom of the list.
      if (aFirstName == bFirstName && !!aLastName && !!bLastName) return aLastName.localeCompare(bLastName); // Only compares Individuals.
      if (a.hasOwnProperty('name')) aUnitName = a.name.toLowerCase();
      if (b.hasOwnProperty('name')) bUnitName = b.name.toLowerCase();
      if (!aFirstName && !!aUnitName) aFirstName = aUnitName; // Either A or B could be a Unit object, assign name of unit to first name.
      if (!bFirstName && !!bUnitName) bFirstName = bUnitName;
      return aFirstName.localeCompare(bFirstName);
  }

  return (
    <div className="Monitored-Individual-Unit-Search" onKeyDown={handleKeyDown} >
      <p className="Monitored-Individual-Unit-Search__heading">Individual/Unit Search:</p>
      <div className="Monitored-Individual-Unit-Search__input-wrapper">
        <FontAwesomeIcon className="Monitored-Individual-Unit-Search__input-icon" icon="search" />
        <input
          ref={setInputRef}
          onKeyDown={handleInputKeyDown}
          placeholder={!monitoredIndividuals ? 'Loading individuals and units...' : 'Name, Unit'}
          readOnly={readOnly || !monitoredIndividuals}
          className={'Monitored-Individual-Unit-Search__input' + (showOverlay ? ' Monitored-Individual-Unit-Search__input--overlay-visible' : '')}
          value={inputValue}
          onChange={updateValue} />
      </div>
      <div
        className={'Monitored-Individual-Unit-Search__selection-backdrop' + (showOverlay ? ' Monitored-Individual-Unit-Search__selection-backdrop--visible' : '')}
        onClick={hideOverlay}></div>
      <ul
        ref={setOverlayRef}
        className={'Monitored-Individual-Unit-Search__selection-overlay' + (showOverlay ? ' Monitored-Individual-Unit-Search__selection-overlay--visible' : '')}>
        {
          filteredItems.length === 0 ?
            <li key="noResults" className="Monitored-Individual-Unit-Search__empty-message">No matching individuals or units found...</li> :
              filteredItems.sort((a,b) => searchSortFilter(a,b)).map((item, index) => {
              return (
                <li
                  className="Monitored-Individual-Unit-Search__list-item"
                  key={item.monitoredIndividualId ? `MI-${item.monitoredIndividualId}` : `Unit-${item.unitId}`}
                  onKeyDown={handleMonitoredIndividualButtonKeyDown}
                >
                  <Link
                    to={item.monitoredIndividualId ? `/monitoredindividual/${item.monitoredIndividualId}` : item.unitId ? `/unit/${item.unitId}` : '/'}
                    className="Monitored-Individual-Unit-Search__monitoredindividual-button"
                    onClick={hideOverlay}
                    ref={index === 0 ? setFirstItemRef : index === filteredItems.length - 1 ? setLastItemRef : null}>
                    {
                      !!item.monitoredIndividualId &&
                      <SimpleMIUserCard
                        miUser={{ monitoredIndividual: item }}
                        border={false} />
                    }
                    {
                      item.unitId &&
                      <UnitCard
                        unit={item}
                        border={false} />
                    }
                  </Link>
                </li>
              )
            })
        }
      </ul>
    </div>
  );
}